import { SET_VALUE } from './intercom.actionTypes';

export const setIntercomValue = (payload) => ({
  type: SET_VALUE, payload,
});
